import { render } from "./FormatIndentDecrease.vue?vue&type=template&id=1fc30292"
import script from "./FormatIndentDecrease.vue?vue&type=script&lang=js"
export * from "./FormatIndentDecrease.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\merk\\Documents\\_kwork\\virginia79\\lk\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__